import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgRfidAlt = function SvgRfidAlt(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M11.994 13.992a2.016 2.016 0 100-4.031 2.016 2.016 0 000 4.031zM2.057 11.977a9.853 9.853 0 012.906-7.032 1.02 1.02 0 000-1.406 1.02 1.02 0 00-1.406 0c-4.688 4.64-4.688 12.234 0 16.922.187.187.468.281.703.281.234 0 .515-.094.703-.281a1.02 1.02 0 000-1.406c-1.875-1.922-2.906-4.407-2.906-7.078zM20.479 3.54a1.02 1.02 0 00-1.407 0 1.02 1.02 0 000 1.405c3.89 3.89 3.89 10.22 0 14.11a1.02 1.02 0 000 1.406c.188.187.469.281.703.281.235 0 .516-.094.704-.281 4.64-4.688 4.64-12.281 0-16.922z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M16.916 7.055a1.02 1.02 0 00-1.406 0 1.02 1.02 0 000 1.406c1.922 1.922 1.922 5.11 0 7.031a1.02 1.02 0 000 1.406c.187.188.469.282.703.282.234 0 .515-.094.703-.282a6.96 6.96 0 000-9.843zM8.479 7.055a1.02 1.02 0 00-1.407 0 6.96 6.96 0 000 9.843c.188.188.469.282.703.282.235 0 .516-.094.704-.282a1.02 1.02 0 000-1.406c-1.922-1.922-1.922-5.11 0-7.031a1.02 1.02 0 000-1.406z"
  }));
};

export default SvgRfidAlt;